import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "search-form-item" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = { class: "search-form-item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_7 = { class: "flex1 display-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_add_button = _resolveComponent("add-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_update_dialog = _resolveComponent("update-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.MulListUpdateListTanleStatus), 1),
        _createVNode(_component_cus_select, {
          modelValue: _ctx.listRequestData.param.Status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.Status = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_cus_option, {
              label: _ctx.$wordList.SelectAll,
              value: ""
            }, null, 8, ["label"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
              return (_openBlock(), _createBlock(_component_cus_option, {
                key: item,
                value: item.value,
                label: item.label
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.listRequestData.param.Version,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.Version = $event)),
          placeholder: _ctx.$wordList.TabelUpdateBoxVersion
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createVNode(_component_cus_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateToList++))
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_add_button, { onClick: _ctx.add }, null, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      requestData: _ctx.listRequestData,
      update: _ctx.updateToList,
      showCheck: false,
      deleteUrl: "deleteupdate",
      showDefaultAction: ['delete'],
      action: _ctx.action
    }, {
      StatusSlot: _withCtx((data) => [
        _createTextVNode(_toDisplayString(_ctx.statusOptions[data.scope.Status].label), 1)
      ]),
      _: 1
    }, 8, ["headers", "requestData", "update", "action"]),
    (_ctx.isShowUpdateDialog)
      ? (_openBlock(), _createBlock(_component_update_dialog, {
          key: 0,
          updateType: _ctx.updateType,
          "init-data": _ctx.initData,
          "init-choose": _ctx.initDeviceID,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowUpdateDialog=false)),
          onSuccess: _ctx.success
        }, null, 8, ["updateType", "init-data", "init-choose", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
}